<template>
  <div v-if="plans && plans.length > 0" class="w-full max-w-2xl mx-auto">
    <div class="mb-4">
      <div class="flex flex-col gap-1.5 pr-2">
        <div
          v-for="(plan, idx) in plans"
          :key="plan.period"
          @click="$emit('select-plan', idx)"
          :class="[
            'bg-[#18181b] rounded-xl border border-1 py-2 px-4 cursor-pointer transition-all duration-200 flex items-center justify-between mt-0.5',
            selectedIndex === idx
              ? 'border-[#9d2890] shadow-[0_0_0_2px_#9d2890]'
              : 'border-gray-600',
          ]"
          dir="rtl"
        >
          <!-- Right side: Title and operators -->
          <div class="flex flex-col items-start">
            <div class="flex items-center gap-2.5 mb-1">
              <span class="md:text-lg text-sm font-bold text-white">{{
                plan.title
              }}</span>
              <span
                v-if="plan.popular"
                class="bg-[#9d2890] text-white rounded px-2 py-1 text-xs font-semibold"
              >
                الأكثر شهرة
              </span>
            </div>
            <div class="text-gray-400 md:text-sm text-[10px] mb-1">
              يمكنك الدفع باستخدام
            </div>
            <div class="flex items-center gap-1">
              <template v-for="op in plan.operators" :key="op">
                <span
                  v-for="(logo, logoIndex) in getOperatorLogos(op)"
                  :key="`${op}-${logoIndex}`"
                  class="text-white py-1 rounded"
                >
                  <img
                    :src="logo"
                    :alt="`${op}-${logoIndex}`"
                    class="w-8 md:w-10 h-8 md:h-10 object-contain"
                  />
                </span>
              </template>
            </div>
          </div>

          <!-- Left side: Price -->
          <div class="flex flex-col items-end">
            <span v-if="selectedIndex === idx" class="mb-1">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="11"
                  stroke="#9d2890"
                  stroke-width="2"
                />
                <path
                  d="M8 12.5L11 15.5L16 10.5"
                  stroke="#9d2890"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="text-gray-300 text-xs">ابتداء من</span>
            <!-- if it has discount add the discount and make line in the original price -->
            <div class="md:text-xl text-sm font-bold text-white">
               <span v-if="plan.discount"
                  class="bg-[#9d2890] text-white rounded px-1 py-0 text-xs font-semibold ml-1"
                  >خصم {{plan.discount}}%</span
                >
              <span
                v-if="plan.discount"
                class="text-gray-500 line-through mr-2 text-sm"
              >
                {{ plan.price.toLocaleString() }}
              </span>
              <span v-if="plan.discount">
                <!-- calcualted the discounted price -->
                {{ (plan.price - (plan.price * plan.discount) / 100).toLocaleString() }}
             
              </span>
              <span v-else>
                {{ plan.price.toLocaleString() }}
              </span>
                
            </div>
            <span class="md:text-sm text-xs text-gray-400">
              {{ currency }}/{{ getPeriodLabel(plan.period) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OPERATOR_LOGOS, PERIOD_LABELS } from "@/constants";

export default {
  name: "CountryPlansList",
  props: {
    plans: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: "جنيه",
    },
  },
  emits: ["select-plan"],
  methods: {
    getOperatorLogo(op) {
      return OPERATOR_LOGOS[op] || "";
    },
    getOperatorLogos(op) {
      // Return array of logos for operators that have multiple logos
      if (op === "stripe" && Array.isArray(OPERATOR_LOGOS[op])) {
        return OPERATOR_LOGOS[op];
      }
      // Return single logo as array for consistency
      return [OPERATOR_LOGOS[op] || ""];
    },
    getPeriodLabel(period) {
      return PERIOD_LABELS[period] || period;
    },
  },
};
</script>

<style scoped>
/* Custom scrollbar styling */
.flex-col::-webkit-scrollbar {
  width: 6px;
}

.flex-col::-webkit-scrollbar-track {
  background: transparent;
}

.flex-col::-webkit-scrollbar-thumb {
  background: #9d2890;
  border-radius: 3px;
}

.flex-col::-webkit-scrollbar-thumb:hover {
  background: #b83bb1;
}

/* For Firefox */
.flex-col {
  scrollbar-width: thin;
  scrollbar-color: #9d2890 transparent;
}
</style>
